import { createSlice } from '@reduxjs/toolkit';
import { getArticleSuccess } from 'state/slices/articles';
import { getAuthorSuccess } from 'state/slices/authors';
import { getCategorySuccess } from 'state/slices/categories';
import { getHomeSuccess } from 'state/slices/home';
import { getPageSuccess } from 'state/slices/pages';

const initialState = {
  type: null,
  id: null
};

const currentResourceSlice = createSlice({
  name: 'currentResource',
  initialState,
  extraReducers: {
    [getArticleSuccess]: (state, { payload }) => {
      state.type = 'post';
      state.id = payload.data.id;
    },
    [getPageSuccess]: (state, { payload }) => {
      state.type = 'page';
      state.id = payload.data.id;
    },
    [getCategorySuccess]: (state, { payload }) => {
      state.type = 'category';
      state.id = payload.data.id;
    },
    [getAuthorSuccess]: (state, { payload }) => {
      state.type = 'user';
      state.id = payload.data.id;
    },
    [getHomeSuccess]: (state) => {
      state.type = null;
      state.id = null;
    }
  }
});

export default currentResourceSlice.reducer;
